<template>
  <div>
    <el-col :span="dateSpan">
      <CommDatePicker
        @change="$emit('change', 'time')"
        type="datetime"
        v-model="propForm[type + 'Time']"
        :value.sync="propForm[type + 'Time']"
        width="100%"
        :disabled="disabled"
        format="yyyy-MM-dd HH:mm"
      />
    </el-col>
  </div>
  
</template>
<script>
import CommDatePicker from "@/components/common/CommDatePicker";

export default {
  data() {
    return {}
  },
  props: {
    propForm: {
      type: Object,
      default: {},
    },
    type: {
      type: String,
      default: 'start',
    },
    typeSpan: {
      type: Number,
      default: 3,
    },
    dateSpan: {
      type: Number,
      default: 5,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CommDatePicker,
  },
}
</script>